// https://uk.wikipedia.org/wiki/%D0%9A%D0%B0%D1%82%D0%B5%D0%B3%D0%BE%D1%80%D1%96%D1%8F:%D0%92%D0%B8%D0%BF%D1%96%D1%87%D0%BA%D0%B0

export default [
  { label: 'Макарони', value: 'Macaroni' },
  { label: 'Торти', value: 'Cakes' },
  { label: 'Капкейки', value: 'Caps' },
  { label: 'Ансаїмаза', value: 'Ansayamaz' },
  { label: 'Балабушки', value: 'Balabushki' },
  { label: 'Амареті (печиво)', value: 'Amareti (cookies)' },
  { label: 'Безе (тістечко)', value: 'Bay (cake)' },
  { label: 'Бісквітне тісто', value: 'Biscuit dough' },
  { label: 'Біф Веллінгтон', value: 'Beef Wellington' },
  { label: 'Блонді (кулінарія)', value: 'Blondes (cooking)' },
  { label: 'Брауні (кулінарія)', value: 'Brownies (cookery)' },
  { label: 'Ватрушка', value: 'Cotton' },
  { label: 'Вергуни (печиво)', value: 'Verguni (cookies)' },
  { label: 'Верч', value: 'Verch' },
  { label: 'Гьозлеме', value: 'Gözleme' },
  { label: 'Доса', value: 'Dosa' },
  { label: 'Дріжджове тісто', value: 'Yeast dough' },
  { label: 'Заварне тісто', value: 'Cake Dough' },
  { label: 'Заварний тарт', value: 'Custard Cake' },
  { label: 'Земляний торт', value: 'Earth cake' },
  { label: 'Калач', value: 'Kalach' },
  { label: 'Калита (ритуальна)', value: 'Kalita (ritual)' },
  { label: 'Катлама', value: 'Katlama' },
  { label: 'Київський торт', value: 'Kyiv cake' },
  { label: 'Кіш (пиріг)', value: 'Kish (cake)' },
  { label: 'Книш', value: 'Knish' },
  { label: 'Команмелна', value: 'Commemnal' },
  { label: 'Коровай', value: 'Cow' },
  { label: 'Крекер', value: 'Cracker' },
  { label: `Кров'яні млинці`, value: 'Blood pancakes' },
  { label: 'Кубдарі', value: 'Cubs' },
  { label: 'Кучюкай', value: 'Kuchukai' },
  { label: 'Легуміна', value: 'Leguminum' },
  {
    label: 'Лежень (весільний обрядовий хліб)',
    value: 'Ledge (wedding ritual bread)'
  },
  { label: 'Мандрики', value: 'Mandriques' },
  { label: 'Млинці', value: 'Pancakes' },
  { label: 'Наполеон (торт)', value: 'Napoleon (cake)' },
  { label: 'Паляниця', value: 'Loaf' },
  { label: 'Пампушка', value: 'Pampushka' },
  { label: 'Паска', value: 'Easter cake' },
  { label: 'Перепічка', value: 'Cake' },
  { label: 'Печиво', value: 'Cookies' },
  { label: 'Пиріг', value: 'Pie' },
  { label: 'Пісочне тісто', value: 'Sand dough' },
  { label: 'Піта', value: 'Pete' },
  { label: 'Піца', value: 'Pizza' },
  { label: 'Плетеник', value: 'Wicker' },
  { label: 'Пряник', value: 'Gingerbread' },
  { label: 'Пухкеник', value: 'Punchkin' },
  { label: 'Ругелах', value: 'Rogelyah' },
  { label: 'Сайка (хліб)', value: 'Saika (bread)' },
  { label: 'Самса', value: 'Samsa' },
  { label: 'Сосиска в тісті', value: 'Sausage in dough' },
  { label: 'Спеттекака', value: 'Sptotecka' },
  { label: 'Струдель', value: 'Strut' },
  { label: 'Тарт Татен', value: 'Tart Tatan' },
  { label: 'Тарталетка', value: 'Tartlet' },
  { label: 'Торт', value: 'Pie' },
  { label: 'Інші категорії...', value: 'Other categories ...' }
];
